import React, {useEffect, useState} from "react";
import {Backdrop, Container, Dialog, DialogContent, Typography} from "@mui/material";
import {ImageList as Image} from '@mui/material';
import ImageListItem from '@mui/material/ImageListItem';
import styles from "../assets/css/imageList.module.scss";
import GallerySlideShow from "./GallerySlideShow";
import configs from "../utils/config.json";

const ImageList = (props) => {
    const [open, setOpen] = useState(false);
    const [images, setImages] = useState([]);
    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    }

    function srcset(image, size, rows = 1, cols = 1) {
        return {
            src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
            srcSet: `${image}?w=${size * cols}&h=${
                size * rows
            }&fit=crop&auto=format&dpr=2 2x`,
        };
    }

    useEffect(() => {
        let array = props.imgs.map((item, index) => {
            if (index % 6 === 0)
                return {
                    img: `${configs.server.Storage}/${item.img}`,
                    cols: 4,
                    rows: 2
                }
            else return {
                img: `${configs.server.Storage}/${item.img}`,
                cols: 2,
                rows: 1
            }
        })
        setImages(array);
    }, [props.imgs]);

    return <div className={styles.container}>
        <Container maxWidth={"xl"}>
            <Typography variant={"subtitle2"} component={"p"}>
                {props.title}
            </Typography>
            <Typography variant={"h4"} component={"h4"}>
                {props.slogan}
            </Typography>
            <Image
                sx={{width: "100%", height: 465}}
                variant="quilted"
                cols={12}
                rowHeight={150}
            >
                {images.map((item, index) => (
                    <ImageListItem key={index} cols={item.cols || 1} rows={item.rows || 1}>
                        <img
                            {...srcset(item.img, 150, item.rows, item.cols)}
                            alt={item.title}
                            loading="lazy"
                            onClick={handleOpen}
                        />
                    </ImageListItem>
                ))}
                {/*{itemData.map((item, index) => (*/}
                {/*    <ImageListItem key={item.img} cols={item.cols || 1} rows={item.rows || 1}>*/}
                {/*        <img*/}
                {/*            {...srcset(item.img, 150, item.rows, item.cols)}*/}
                {/*            alt={item.title}*/}
                {/*            loading="lazy"*/}
                {/*            onClick={handleOpen}*/}
                {/*        />*/}
                {/*    </ImageListItem>*/}
                {/*))}*/}
            </Image>
        </Container>
        {/*<Backdrop*/}
        {/*    sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}*/}
        {/*    open={open}*/}
        {/*    onClick={handleClose}*/}
        {/*>*/}
        {/*    <GallerySlideShow/>*/}
        {/*</Backdrop>*/}

        <Dialog
            fullWidth={true}
            maxWidth={"md"}
            open={open}
            onClose={handleClose}

        >
            <DialogContent>

                <GallerySlideShow list={images}/>

            </DialogContent>

        </Dialog>
    </div>;
};
const itemData = [
    {
        img: 'https://images.unsplash.com/photo-1551963831-b3b1ca40c98e',
        title: 'Breakfast',
        rows: 2,
        cols: 2,
    },
    {
        img: 'https://images.unsplash.com/photo-1551782450-a2132b4ba21d',
        title: 'Burger',
    },
    {
        img: 'https://images.unsplash.com/photo-1522770179533-24471fcdba45',
        title: 'Camera',
    },
    {
        img: 'https://images.unsplash.com/photo-1444418776041-9c7e33cc5a9c',
        title: 'Coffee',
        cols: 2,
    },
    {
        img: 'https://images.unsplash.com/photo-1533827432537-70133748f5c8',
        title: 'Hats',
        cols: 2,
    },
    {
        img: 'https://images.unsplash.com/photo-1558642452-9d2a7deb7f62',
        title: 'Honey',
        author: '@arwinneil',
        rows: 2,
        cols: 2,
    },
    {
        img: 'https://images.unsplash.com/photo-1516802273409-68526ee1bdd6',
        title: 'Basketball',
    },
    {
        img: 'https://images.unsplash.com/photo-1518756131217-31eb79b20e8f',
        title: 'Fern',
    },
    {
        img: 'https://images.unsplash.com/photo-1597645587822-e99fa5d45d25',
        title: 'Mushrooms',
        rows: 2,
        cols: 2,
    },
    {
        img: 'https://images.unsplash.com/photo-1567306301408-9b74779a11af',
        title: 'Tomato basil',
    },
    {
        img: 'https://images.unsplash.com/photo-1471357674240-e1a485acb3e1',
        title: 'Sea star',
    },
    {
        img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',
        title: 'Bike',
        cols: 2,
    },
    {
        img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',
        title: 'Bike',
        cols: 2,
    }, {
        img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',
        title: 'Bike',
        cols: 2,
    }, {
        img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',
        title: 'Bike',
        cols: 2,
    }, {
        img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',
        title: 'Bike',
        cols: 2,
    }, {
        img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',
        title: 'Bike',
        cols: 2,
    }, {
        img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',
        title: 'Bike',
        cols: 2,
    },
];
export default ImageList;